export enum OfflineContentStatus {
  Full,
  Partial,
  None
}
